import { render, staticRenderFns } from "./viewList.vue?vue&type=template&id=0af5aee3&scoped=true&"
import script from "./viewList.vue?vue&type=script&lang=js&"
export * from "./viewList.vue?vue&type=script&lang=js&"
import style0 from "./viewList.vue?vue&type=style&index=0&id=0af5aee3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af5aee3",
  null
  
)

export default component.exports